import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES} from '../../../_config/strings';
import {Usuario} from '../../../_model/Usuario';
import { Cliente } from '../../../_model/Cliente';
import Swal from 'sweetalert2';
import { ChatService } from '../../../_services/chat.service';
import {Subject} from 'rxjs/Subject';

declare var $: any;

@Component({
  selector: 'app-listar-clientes-orden',
  templateUrl: './listar-clientes-orden.component.html',
  styleUrls: ['./listar-clientes-orden.component.scss']
})
export class ListarClientesOrdenComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  public usuario: Usuario = new Usuario();
  public cliente: Cliente = new Cliente();

  // array´s
  arrayClientes = [];

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
   }

  ngOnInit() {
    this.listarClientesOrdenPendiente();
  }

  listarClientesOrdenPendiente () {
    this.network.callSecureService(
      this.API.user.contabilidad + '/' + this.API.user.clientes,
      'GET',
      null)
      .subscribe((response: any) => {
        console.log( response );
        response.Mensaje.clientesNormales.forEach(element => {
          if ( element.abastecimiento.estatus.estatus === 'ORDPEND' || element.abastecimiento.estatus.estatus === 'AUTCOMP' ) {
            this.arrayClientes.push({
              abastecimientoId: element.abastecimiento.abastecimientoId,
              concepto: element.abastecimiento.concepto,
              abastecimientoEstatus: element.abastecimiento.estatus,
              contratoId: element.contrato.contratoId,
              noContrato: element.contrato.noContrato,
              // --
              sucursal: element.cliente.sucursalNombre,
              atentido: element.cliente.usuario,
              // --
              clienteId: element.cliente.clienteId,
              nombreCliente: element.cliente.nombre,
              apellidoCliente: element.cliente.apellido,
              clienteFM: element.cliente.razonSocial !== '' || element.cliente.razonSocial == null ? element.cliente.razonSocial : element.cliente.nombre + ' ' + element.cliente.apellido,
              rfc: element.cliente.rfc,
              razonSocial: element.cliente.razonSocial,
              tipoCliente: element.cliente.tipoCliente,
              clienteEstatus: element.cliente.estatus
            });
          }
        });
        this.dtTrigger.next();
      }, err => {
        console.log(err);
        Swal('Error', err.error.error.exception[0].message, 'error');
      });
  }

  rowSeleccionado (info: any) {
    this.ruta.navigate(['dashboard', 'verCliente', info.clienteId, 'contratos', info.noContrato, 'abastecimiento', info.abastecimientoId]);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-clientes-orden/listar-clientes-orden.component.ts